export class Gls {
  text!: string;
  address!: GlsAddress;
}

export class GlsAddress {
 id!: string;
 houseNumber!: string;
 zipCode!: string;
 street!: string;
 countryCode!: string;
 region!: string;
 country!: string;
 city!: string | null;
 latitude!: number;
 longitude!: number;
 address!: string;
 door!: string;
 floor!: string;
 litra!: string;
 constructor(init?: Partial<GlsAddress>) {
    Object.assign(this, init);
  }
}
